import API from './API';

const impl = {
};

export default new API(impl);



// WEBPACK FOOTER //
// ./src/app/HTTPAPI.js